<template>
	<tr class="requirement-record">
		<td class="pa-1 normal-wrap text-center" v-text="drawing.file_number"></td>
		<td class="pa-1 normal-wrap text-center" v-text="drawing.answer_status"></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="drawing.type_tag.name.match(/社外秘/) ? '○' : ''"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="drawing.return_attached_file_info.name"
			@click="openfile"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="toDateFormat(drawing.return_attached_file_info.created_at)"
		></td>
		<td
			class="pa-1 normal-wrap text-center"
			v-text="drawing.user.last_name + ' ' + drawing.user.first_name"
		></td>
		<td class="pa-1 normal-wrap text-center">
			<p
				class="pa-1 pre-wrap text-center"
				v-if="drawing.return_attached_file_info.matter"
				@click="matterDialog = true"
				v-text="
					drawing.return_attached_file_info.matter
						? common.returnMatterInfo(drawing.return_attached_file_info.matter)
						: ''
				"
			></p>
		</td>
		<td class="pa-1 normal-wrap text-center" v-text="drawing.destroy_flag ? '済' : ''"></td>
		<MatterShowDialog
			v-if="matterDialog"
			:id="drawing.return_attached_file_info.matter.id"
			:requiredFetch="true"
			@close="matterDialog = false"
		/>
	</tr>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import moment from "moment/min/moment.min.js"
import common from "../../../helper/common.js"
import MatterShowDialog from "../../matter/components/MatterShowDialog.vue"

export default {
	components: {
		MatterShowDialog,
	},
	props: {
		drawing: {},
		recordIndex: "",
	},
	data() {
		return {
			common: common,
			matterDialog: false,
		}
	},
	filters: {
		dateForRequirement: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeForRequirement: function (time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
		filterYear: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY")
		},
		filterMonth: function (date) {
			if (!date) return ""
			return moment(date).format("MM")
		},
		filterDay: function (date) {
			if (!date) return ""
			return moment(date).format("DD")
		},
	},
	watch: {},

	methods: {
		openfile() {
			if (!this.drawing.destroy_flag) {
				window.open(this.drawing.return_attached_file_info.url, "_blank")
			}
		},
		reloadIndex() {
			this.$emit("reloadIndex")
		},
		openEditDialog(target, nowData, valueId = "") {
			this.$refs.edit.openDialog(this.requirement, target, nowData, valueId)
		},
		selectQuotePrice(word) {
			let returnPrice = null
			this.matter.quote_requests.forEach((qr) => {
				if (qr.logi_quote) {
					if (qr.supplier.name == word) {
						returnPrice = qr.logi_quote.price
					}
				}
			})
			return returnPrice
		},
		getQuoteRequestNumber() {
			if (this.matter.quote_requests.length > 0) {
				let numbers = this.matter.quote_requests.map((obj) => obj.quote_number).join(", ")
				return numbers
			}
		},
		getQuoteRequestAnswerDate() {
			if (this.matter.quote_requests.length > 0) {
				let dates = []
				dates = this.matter.quote_requests.map((obj) => {
					if (obj.answer_date) {
						return obj.answer_date
					}
				})
				let datesString = dates
					.map((date) => {
						if (date) {
							return moment(date).format("YYYY/MM/DD")
						}
					})
					.join(", ")
				return datesString
			}
		},
		redirectToShowPage() {},
		toDateFormat(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD")
			} else {
				return null
			}
		},
		selectValueDataFromValues(name) {
			let returnValue = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnValue = value
					}
				})
			}
			return returnValue
		},
		selectValueIdFromValues(name) {
			let returnId = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnId = value.id
					}
				})
			}
			return returnId
		},
		selectValueFromValues(name) {
			let returnValue = null
			if (this.answer) {
				this.answer.answer_values.forEach((value) => {
					if (value.answer_column.name == name) {
						returnValue = value
					}
				})
				if (returnValue != null) {
					return common.returnValueValue(returnValue)
				} else {
					return null
				}
			} else {
				return null
			}
		},
		latestDeliveryInfo(infos) {
			let sorted = this.common.sortCreatedAtDESC(infos)
			return sorted[0]
		},
	},
	computed: {},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
td {
	white-space: pre-wrap;
}

.requirement-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.requirement-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
